<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight,
    };
  },
  mounted() {
    window.addEventListener("resize", this.updateViewportSize);
    this.updateViewportSize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateViewportSize);
  },
  methods: {
    updateViewportSize() {
      this.viewportWidth = window.innerWidth;
      this.viewportHeight = window.innerHeight;
      this.$emit(
        "viewport-size-update",
        this.viewportWidth,
        this.viewportHeight
      );
    },
  },
};
</script>